import { useState } from 'react';

const EMPTY = {
  first_name: '',
  last_name: '',
  ig_username: '',
  personal_ig_username: '',
  email: '',
  phone_prefix: '',
  phone_number: '',
  country: '',
  city: '',
  birthdate: '',
  usdc_wallet: '',
  password: '',
  password_confirm: '',
};

export type SignupFields = typeof EMPTY;
export type FieldErrors = Partial<Record<keyof SignupFields, string>>;

type Consents = {
  agreed: boolean;
  toggleAgreed: () => void;
  agreedError: string;
  setAgreedError: (m: string) => void;
};

export type FormState = Consents & {
  data: SignupFields;
  setData: (d: SignupFields) => void;
  error: string;
  setError: (e: string) => void;
  fieldErrors: FieldErrors;
  setFieldErrors: (f: FieldErrors) => void;
};

function useConsents(): Consents {
  const [agreed, setAgreed] = useState(false);
  const [agreedError, setAgreedError] = useState('');
  return {
    agreed,
    toggleAgreed: () => setAgreed(!agreed),
    agreedError,
    setAgreedError,
  };
}

export function useFormState(): FormState {
  const [data, setData] = useState(EMPTY);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState<FieldErrors>({});
  const consents = useConsents();
  return {
    data,
    setData,
    error,
    setError,
    fieldErrors,
    setFieldErrors,
    ...consents,
  };
}
